import capitalize from 'lodash/capitalize';
import kebabCase from 'lodash/kebabCase';

const prettyLabel = (str: string): string => kebabCase(str).split('-').map(capitalize).join(' ');

export default prettyLabel;
